import type { InvoiceRow } from "@/types/api";

export type InvoiceSortKey = "created-desc" | "created-asc";

export function sortInvoices(
  rows: InvoiceRow[],
  sortKey: InvoiceSortKey = "created-desc",
): InvoiceRow[] {
  const copy = [...rows];
  copy.sort((a, b) => {
    const diff = a.created - b.created;
    return sortKey === "created-desc" ? -diff : diff;
  });
  return copy;
}
